<template>
  <div>
    <template v-for="(idx,i) in worklists">
      <div class="pl-50" v-bind:key="'idx-'+i" v-if="allowedWorklists.indexOf(idx.ref_number) !== -1 || idx.parent != ''">
        <div class="row-report mb-20">
          <div @click="worklistsDetails(idx)">
            <div class="light" :class="idx.light != 'nocolor' ? idx.light : ''"></div>
            <div class="overflow-scroll-mobile">
              <span>Ref. number: {{ idx.ref_number }}</span>
              <span>{{ idx.title }}</span>
            </div>
          </div>
        </div>
        <report-worklist-index :allowedWorklists="allowedWorklists" :worklists="idx.indices" @worklistsDetails="(idx) => worklistsDetails(idx)"></report-worklist-index>
      </div>
    </template>
  </div>
</template>

<script>
// import axios from "axios"
// import Vue from "vue"
export default {
  name: "ReportWorklistIndex",
  props: ['worklists', 'allowedWorklists'],
  data: function() {
    return {
    }
  },
  methods: {
    worklistsDetails: function(idx) {
      this.$emit('worklistsDetails', idx)
    }
  },
  created: function() {
  },
  mounted: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>